export interface HcPhoneCountryCode {
  _id: string;
  nameKey: string;
  flagIcon: string;
  phoneCountryCode: string;
}

export function getCountryCodes(): HcPhoneCountryCode[] {
  return [
    {
      "_id": "US",
      "nameKey": "countryCodes.US",
      "flagIcon": "🇺🇸",
      "phoneCountryCode": "+1"
    },
    {
      "_id": "CA",
      "nameKey": "countryCodes.CA",
      "flagIcon": "🇨🇦",
      "phoneCountryCode": "+1"
    },
    {
      "_id": "GB",
      "nameKey": "countryCodes.GB",
      "flagIcon": "🇬🇧",
      "phoneCountryCode": "+44"
    },
    {
      "_id": "AU",
      "nameKey": "countryCodes.AU",
      "flagIcon": "🇦🇺",
      "phoneCountryCode": "+61"
    },
    {
      "_id": "DE",
      "nameKey": "countryCodes.DE",
      "flagIcon": "🇩🇪",
      "phoneCountryCode": "+49"
    },
    {
      "_id": "FR",
      "nameKey": "countryCodes.FR",
      "flagIcon": "🇫🇷",
      "phoneCountryCode": "+33"
    },
    {
      "_id": "IT",
      "nameKey": "countryCodes.IT",
      "flagIcon": "🇮🇹",
      "phoneCountryCode": "+39"
    },
    {
      "_id": "ES",
      "nameKey": "countryCodes.ES",
      "flagIcon": "🇪🇸",
      "phoneCountryCode": "+34"
    },
    {
      "_id": "NL",
      "nameKey": "countryCodes.NL",
      "flagIcon": "🇳🇱",
      "phoneCountryCode": "+31"
    },
    {
      "_id": "BE",
      "nameKey": "countryCodes.BE",
      "flagIcon": "🇧🇪",
      "phoneCountryCode": "+32"
    },
    {
      "_id": "CH",
      "nameKey": "countryCodes.CH",
      "flagIcon": "🇨🇭",
      "phoneCountryCode": "+41"
    },
    {
      "_id": "AT",
      "nameKey": "countryCodes.AT",
      "flagIcon": "🇦🇹",
      "phoneCountryCode": "+43"
    },
    {
      "_id": "SE",
      "nameKey": "countryCodes.SE",
      "flagIcon": "🇸🇪",
      "phoneCountryCode": "+46"
    },
    {
      "_id": "NO",
      "nameKey": "countryCodes.NO",
      "flagIcon": "🇳🇴",
      "phoneCountryCode": "+47"
    },
    {
      "_id": "DK",
      "nameKey": "countryCodes.DK",
      "flagIcon": "🇩🇰",
      "phoneCountryCode": "+45"
    },
    {
      "_id": "FI",
      "nameKey": "countryCodes.FI",
      "flagIcon": "🇫🇮",
      "phoneCountryCode": "+358"
    },
    {
      "_id": "IE",
      "nameKey": "countryCodes.IE",
      "flagIcon": "🇮🇪",
      "phoneCountryCode": "+353"
    },
    {
      "_id": "PT",
      "nameKey": "countryCodes.PT",
      "flagIcon": "🇵🇹",
      "phoneCountryCode": "+351"
    },
    {
      "_id": "GR",
      "nameKey": "countryCodes.GR",
      "flagIcon": "🇬🇷",
      "phoneCountryCode": "+30"
    },
    {
      "_id": "PL",
      "nameKey": "countryCodes.PL",
      "flagIcon": "🇵🇱",
      "phoneCountryCode": "+48"
    },
    {
      "_id": "CZ",
      "nameKey": "countryCodes.CZ",
      "flagIcon": "🇨🇿",
      "phoneCountryCode": "+420"
    },
    {
      "_id": "HU",
      "nameKey": "countryCodes.HU",
      "flagIcon": "🇭🇺",
      "phoneCountryCode": "+36"
    },
    {
      "_id": "SK",
      "nameKey": "countryCodes.SK",
      "flagIcon": "🇸🇰",
      "phoneCountryCode": "+421"
    },
    {
      "_id": "SI",
      "nameKey": "countryCodes.SI",
      "flagIcon": "🇸🇮",
      "phoneCountryCode": "+386"
    },
    {
      "_id": "HR",
      "nameKey": "countryCodes.HR",
      "flagIcon": "🇭🇷",
      "phoneCountryCode": "+385"
    },
    {
      "_id": "BG",
      "nameKey": "countryCodes.BG",
      "flagIcon": "🇧🇬",
      "phoneCountryCode": "+359"
    },
    {
      "_id": "RO",
      "nameKey": "countryCodes.RO",
      "flagIcon": "🇷🇴",
      "phoneCountryCode": "+40"
    },
    {
      "_id": "LT",
      "nameKey": "countryCodes.LT",
      "flagIcon": "🇱🇹",
      "phoneCountryCode": "+370"
    },
    {
      "_id": "LV",
      "nameKey": "countryCodes.LV",
      "flagIcon": "🇱🇻",
      "phoneCountryCode": "+371"
    },
    {
      "_id": "EE",
      "nameKey": "countryCodes.EE",
      "flagIcon": "🇪🇪",
      "phoneCountryCode": "+372"
    },
    {
      "_id": "LU",
      "nameKey": "countryCodes.LU",
      "flagIcon": "🇱🇺",
      "phoneCountryCode": "+352"
    },
    {
      "_id": "MT",
      "nameKey": "countryCodes.MT",
      "flagIcon": "🇲🇹",
      "phoneCountryCode": "+356"
    },
    {
      "_id": "CY",
      "nameKey": "countryCodes.CY",
      "flagIcon": "🇨🇾",
      "phoneCountryCode": "+357"
    },
    {
      "_id": "IS",
      "nameKey": "countryCodes.IS",
      "flagIcon": "🇮🇸",
      "phoneCountryCode": "+354"
    },
    {
      "_id": "JP",
      "nameKey": "countryCodes.JP",
      "flagIcon": "🇯🇵",
      "phoneCountryCode": "+81"
    },
    {
      "_id": "KR",
      "nameKey": "countryCodes.KR",
      "flagIcon": "🇰🇷",
      "phoneCountryCode": "+82"
    },
    {
      "_id": "CN",
      "nameKey": "countryCodes.CN",
      "flagIcon": "🇨🇳",
      "phoneCountryCode": "+86"
    },
    {
      "_id": "IN",
      "nameKey": "countryCodes.IN",
      "flagIcon": "🇮🇳",
      "phoneCountryCode": "+91"
    },
    {
      "_id": "SG",
      "nameKey": "countryCodes.SG",
      "flagIcon": "🇸🇬",
      "phoneCountryCode": "+65"
    },
    {
      "_id": "HK",
      "nameKey": "countryCodes.HK",
      "flagIcon": "🇭🇰",
      "phoneCountryCode": "+852"
    },
    {
      "_id": "TW",
      "nameKey": "countryCodes.TW",
      "flagIcon": "🇹🇼",
      "phoneCountryCode": "+886"
    },
    {
      "_id": "TH",
      "nameKey": "countryCodes.TH",
      "flagIcon": "🇹🇭",
      "phoneCountryCode": "+66"
    },
    {
      "_id": "MY",
      "nameKey": "countryCodes.MY",
      "flagIcon": "🇲🇾",
      "phoneCountryCode": "+60"
    },
    {
      "_id": "ID",
      "nameKey": "countryCodes.ID",
      "flagIcon": "🇮🇩",
      "phoneCountryCode": "+62"
    },
    {
      "_id": "PH",
      "nameKey": "countryCodes.PH",
      "flagIcon": "🇵🇭",
      "phoneCountryCode": "+63"
    },
    {
      "_id": "VN",
      "nameKey": "countryCodes.VN",
      "flagIcon": "🇻🇳",
      "phoneCountryCode": "+84"
    },
    {
      "_id": "BR",
      "nameKey": "countryCodes.BR",
      "flagIcon": "🇧🇷",
      "phoneCountryCode": "+55"
    },
    {
      "_id": "AR",
      "nameKey": "countryCodes.AR",
      "flagIcon": "🇦🇷",
      "phoneCountryCode": "+54"
    },
    {
      "_id": "CL",
      "nameKey": "countryCodes.CL",
      "flagIcon": "🇨🇱",
      "phoneCountryCode": "+56"
    },
    {
      "_id": "CO",
      "nameKey": "countryCodes.CO",
      "flagIcon": "🇨🇴",
      "phoneCountryCode": "+57"
    },
    {
      "_id": "PE",
      "nameKey": "countryCodes.PE",
      "flagIcon": "🇵🇪",
      "phoneCountryCode": "+51"
    },
    {
      "_id": "MX",
      "nameKey": "countryCodes.MX",
      "flagIcon": "🇲🇽",
      "phoneCountryCode": "+52"
    },
    {
      "_id": "ZA",
      "nameKey": "countryCodes.ZA",
      "flagIcon": "🇿🇦",
      "phoneCountryCode": "+27"
    },
    {
      "_id": "EG",
      "nameKey": "countryCodes.EG",
      "flagIcon": "🇪🇬",
      "phoneCountryCode": "+20"
    },
    {
      "_id": "NG",
      "nameKey": "countryCodes.NG",
      "flagIcon": "🇳🇬",
      "phoneCountryCode": "+234"
    },
    {
      "_id": "KE",
      "nameKey": "countryCodes.KE",
      "flagIcon": "🇰🇪",
      "phoneCountryCode": "+254"
    },
    {
      "_id": "GH",
      "nameKey": "countryCodes.GH",
      "flagIcon": "🇬🇭",
      "phoneCountryCode": "+233"
    },
    {
      "_id": "MA",
      "nameKey": "countryCodes.MA",
      "flagIcon": "🇲🇦",
      "phoneCountryCode": "+212"
    },
    {
      "_id": "TN",
      "nameKey": "countryCodes.TN",
      "flagIcon": "🇹🇳",
      "phoneCountryCode": "+216"
    },
    {
      "_id": "IL",
      "nameKey": "countryCodes.IL",
      "flagIcon": "🇮🇱",
      "phoneCountryCode": "+972"
    },
    {
      "_id": "AE",
      "nameKey": "countryCodes.AE",
      "flagIcon": "🇦🇪",
      "phoneCountryCode": "+971"
    },
    {
      "_id": "SA",
      "nameKey": "countryCodes.SA",
      "flagIcon": "🇸🇦",
      "phoneCountryCode": "+966"
    },
    {
      "_id": "QA",
      "nameKey": "countryCodes.QA",
      "flagIcon": "🇶🇦",
      "phoneCountryCode": "+974"
    },
    {
      "_id": "KW",
      "nameKey": "countryCodes.KW",
      "flagIcon": "🇰🇼",
      "phoneCountryCode": "+965"
    },
    {
      "_id": "BH",
      "nameKey": "countryCodes.BH",
      "flagIcon": "🇧🇭",
      "phoneCountryCode": "+973"
    },
    {
      "_id": "OM",
      "nameKey": "countryCodes.OM",
      "flagIcon": "🇴🇲",
      "phoneCountryCode": "+968"
    },
    {
      "_id": "JO",
      "nameKey": "countryCodes.JO",
      "flagIcon": "🇯🇴",
      "phoneCountryCode": "+962"
    },
    {
      "_id": "LB",
      "nameKey": "countryCodes.LB",
      "flagIcon": "🇱🇧",
      "phoneCountryCode": "+961"
    },
    {
      "_id": "TR",
      "nameKey": "countryCodes.TR",
      "flagIcon": "🇹🇷",
      "phoneCountryCode": "+90"
    },
    {
      "_id": "RU",
      "nameKey": "countryCodes.RU",
      "flagIcon": "🇷🇺",
      "phoneCountryCode": "+7"
    },
    {
      "_id": "UA",
      "nameKey": "countryCodes.UA",
      "flagIcon": "🇺🇦",
      "phoneCountryCode": "+380"
    },
    {
      "_id": "BY",
      "nameKey": "countryCodes.BY",
      "flagIcon": "🇧🇾",
      "phoneCountryCode": "+375"
    },
    {
      "_id": "KZ",
      "nameKey": "countryCodes.KZ",
      "flagIcon": "🇰🇿",
      "phoneCountryCode": "+7"
    },
    {
      "_id": "UZ",
      "nameKey": "countryCodes.UZ",
      "flagIcon": "🇺🇿",
      "phoneCountryCode": "+998"
    },
    {
      "_id": "NZ",
      "nameKey": "countryCodes.NZ",
      "flagIcon": "🇳🇿",
      "phoneCountryCode": "+64"
    },
    {
      "_id": "FJ",
      "nameKey": "countryCodes.FJ",
      "flagIcon": "🇫🇯",
      "phoneCountryCode": "+679"
    },
    {
      "_id": "PG",
      "nameKey": "countryCodes.PG",
      "flagIcon": "🇵🇬",
      "phoneCountryCode": "+675"
    },
    {
      "_id": "BD",
      "nameKey": "countryCodes.BD",
      "flagIcon": "🇧🇩",
      "phoneCountryCode": "+880"
    },
    {
      "_id": "PK",
      "nameKey": "countryCodes.PK",
      "flagIcon": "🇵🇰",
      "phoneCountryCode": "+92"
    },
    {
      "_id": "LK",
      "nameKey": "countryCodes.LK",
      "flagIcon": "🇱🇰",
      "phoneCountryCode": "+94"
    },
    {
      "_id": "NP",
      "nameKey": "countryCodes.NP",
      "flagIcon": "🇳🇵",
      "phoneCountryCode": "+977"
    },
    {
      "_id": "BT",
      "nameKey": "countryCodes.BT",
      "flagIcon": "🇧🇹",
      "phoneCountryCode": "+975"
    },
    {
      "_id": "MV",
      "nameKey": "countryCodes.MV",
      "flagIcon": "🇲🇻",
      "phoneCountryCode": "+960"
    },
    {
      "_id": "AF",
      "nameKey": "countryCodes.AF",
      "flagIcon": "🇦🇫",
      "phoneCountryCode": "+93"
    },
    {
      "_id": "IR",
      "nameKey": "countryCodes.IR",
      "flagIcon": "🇮🇷",
      "phoneCountryCode": "+98"
    },
    {
      "_id": "IQ",
      "nameKey": "countryCodes.IQ",
      "flagIcon": "🇮🇶",
      "phoneCountryCode": "+964"
    },
    {
      "_id": "SY",
      "nameKey": "countryCodes.SY",
      "flagIcon": "🇸🇾",
      "phoneCountryCode": "+963"
    },
    {
      "_id": "YE",
      "nameKey": "countryCodes.YE",
      "flagIcon": "🇾🇪",
      "phoneCountryCode": "+967"
    },
    {
      "_id": "AD",
      "nameKey": "countryCodes.AD",
      "flagIcon": "🇦🇩",
      "phoneCountryCode": "+376"
    },
    {
      "_id": "AL",
      "nameKey": "countryCodes.AL",
      "flagIcon": "🇦🇱",
      "phoneCountryCode": "+355"
    },
    {
      "_id": "DZ",
      "nameKey": "countryCodes.DZ",
      "flagIcon": "🇩🇿",
      "phoneCountryCode": "+213"
    },
    {
      "_id": "AO",
      "nameKey": "countryCodes.AO",
      "flagIcon": "🇦🇴",
      "phoneCountryCode": "+244"
    },
    {
      "_id": "AG",
      "nameKey": "countryCodes.AG",
      "flagIcon": "🇦🇬",
      "phoneCountryCode": "+1268"
    },
    {
      "_id": "AM",
      "nameKey": "countryCodes.AM",
      "flagIcon": "🇦🇲",
      "phoneCountryCode": "+374"
    },
    {
      "_id": "AZ",
      "nameKey": "countryCodes.AZ",
      "flagIcon": "🇦🇿",
      "phoneCountryCode": "+994"
    },
    {
      "_id": "BS",
      "nameKey": "countryCodes.BS",
      "flagIcon": "🇧🇸",
      "phoneCountryCode": "+1242"
    },
    {
      "_id": "BB",
      "nameKey": "countryCodes.BB",
      "flagIcon": "🇧🇧",
      "phoneCountryCode": "+1246"
    },
    {
      "_id": "BZ",
      "nameKey": "countryCodes.BZ",
      "flagIcon": "🇧🇿",
      "phoneCountryCode": "+501"
    },
    {
      "_id": "BJ",
      "nameKey": "countryCodes.BJ",
      "flagIcon": "🇧🇯",
      "phoneCountryCode": "+229"
    },
    {
      "_id": "BO",
      "nameKey": "countryCodes.BO",
      "flagIcon": "🇧🇴",
      "phoneCountryCode": "+591"
    },
    {
      "_id": "BA",
      "nameKey": "countryCodes.BA",
      "flagIcon": "🇧🇦",
      "phoneCountryCode": "+387"
    },
    {
      "_id": "BW",
      "nameKey": "countryCodes.BW",
      "flagIcon": "🇧🇼",
      "phoneCountryCode": "+267"
    },
    {
      "_id": "BN",
      "nameKey": "countryCodes.BN",
      "flagIcon": "🇧🇳",
      "phoneCountryCode": "+673"
    },
    {
      "_id": "BF",
      "nameKey": "countryCodes.BF",
      "flagIcon": "🇧🇫",
      "phoneCountryCode": "+226"
    },
    {
      "_id": "BI",
      "nameKey": "countryCodes.BI",
      "flagIcon": "🇧🇮",
      "phoneCountryCode": "+257"
    },
    {
      "_id": "KH",
      "nameKey": "countryCodes.KH",
      "flagIcon": "🇰🇭",
      "phoneCountryCode": "+855"
    },
    {
      "_id": "CM",
      "nameKey": "countryCodes.CM",
      "flagIcon": "🇨🇲",
      "phoneCountryCode": "+237"
    },
    {
      "_id": "CV",
      "nameKey": "countryCodes.CV",
      "flagIcon": "🇨🇻",
      "phoneCountryCode": "+238"
    },
    {
      "_id": "CF",
      "nameKey": "countryCodes.CF",
      "flagIcon": "🇨🇫",
      "phoneCountryCode": "+236"
    },
    {
      "_id": "TD",
      "nameKey": "countryCodes.TD",
      "flagIcon": "🇹🇩",
      "phoneCountryCode": "+235"
    },
    {
      "_id": "KM",
      "nameKey": "countryCodes.KM",
      "flagIcon": "🇰🇲",
      "phoneCountryCode": "+269"
    },
    {
      "_id": "CG",
      "nameKey": "countryCodes.CG",
      "flagIcon": "🇨🇬",
      "phoneCountryCode": "+242"
    },
    {
      "_id": "CD",
      "nameKey": "countryCodes.CD",
      "flagIcon": "🇨🇩",
      "phoneCountryCode": "+243"
    },
    {
      "_id": "CR",
      "nameKey": "countryCodes.CR",
      "flagIcon": "🇨🇷",
      "phoneCountryCode": "+506"
    },
    {
      "_id": "CU",
      "nameKey": "countryCodes.CU",
      "flagIcon": "🇨🇺",
      "phoneCountryCode": "+53"
    },
    {
      "_id": "DJ",
      "nameKey": "countryCodes.DJ",
      "flagIcon": "🇩🇯",
      "phoneCountryCode": "+253"
    },
    {
      "_id": "DM",
      "nameKey": "countryCodes.DM",
      "flagIcon": "🇩🇲",
      "phoneCountryCode": "+1767"
    },
    {
      "_id": "DO",
      "nameKey": "countryCodes.DO",
      "flagIcon": "🇩🇴",
      "phoneCountryCode": "+1809"
    },
    {
      "_id": "EC",
      "nameKey": "countryCodes.EC",
      "flagIcon": "🇪🇨",
      "phoneCountryCode": "+593"
    },
    {
      "_id": "SV",
      "nameKey": "countryCodes.SV",
      "flagIcon": "🇸🇻",
      "phoneCountryCode": "+503"
    },
    {
      "_id": "GQ",
      "nameKey": "countryCodes.GQ",
      "flagIcon": "🇬🇶",
      "phoneCountryCode": "+240"
    },
    {
      "_id": "ER",
      "nameKey": "countryCodes.ER",
      "flagIcon": "🇪🇷",
      "phoneCountryCode": "+291"
    },
    {
      "_id": "ET",
      "nameKey": "countryCodes.ET",
      "flagIcon": "🇪🇹",
      "phoneCountryCode": "+251"
    },
    {
      "_id": "GA",
      "nameKey": "countryCodes.GA",
      "flagIcon": "🇬🇦",
      "phoneCountryCode": "+241"
    },
    {
      "_id": "GM",
      "nameKey": "countryCodes.GM",
      "flagIcon": "🇬🇲",
      "phoneCountryCode": "+220"
    },
    {
      "_id": "GE",
      "nameKey": "countryCodes.GE",
      "flagIcon": "🇬🇪",
      "phoneCountryCode": "+995"
    },
    {
      "_id": "GD",
      "nameKey": "countryCodes.GD",
      "flagIcon": "🇬🇩",
      "phoneCountryCode": "+1473"
    },
    {
      "_id": "GT",
      "nameKey": "countryCodes.GT",
      "flagIcon": "🇬🇹",
      "phoneCountryCode": "+502"
    },
    {
      "_id": "GN",
      "nameKey": "countryCodes.GN",
      "flagIcon": "🇬🇳",
      "phoneCountryCode": "+224"
    },
    {
      "_id": "GW",
      "nameKey": "countryCodes.GW",
      "flagIcon": "🇬🇼",
      "phoneCountryCode": "+245"
    },
    {
      "_id": "GY",
      "nameKey": "countryCodes.GY",
      "flagIcon": "🇬🇾",
      "phoneCountryCode": "+592"
    },
    {
      "_id": "HT",
      "nameKey": "countryCodes.HT",
      "flagIcon": "🇭🇹",
      "phoneCountryCode": "+509"
    },
    {
      "_id": "HN",
      "nameKey": "countryCodes.HN",
      "flagIcon": "🇭🇳",
      "phoneCountryCode": "+504"
    },
    {
      "_id": "JM",
      "nameKey": "countryCodes.JM",
      "flagIcon": "🇯🇲",
      "phoneCountryCode": "+1876"
    },
    {
      "_id": "KI",
      "nameKey": "countryCodes.KI",
      "flagIcon": "🇰🇮",
      "phoneCountryCode": "+686"
    },
    {
      "_id": "KG",
      "nameKey": "countryCodes.KG",
      "flagIcon": "🇰🇬",
      "phoneCountryCode": "+996"
    },
    {
      "_id": "LA",
      "nameKey": "countryCodes.LA",
      "flagIcon": "🇱🇦",
      "phoneCountryCode": "+856"
    },
    {
      "_id": "LS",
      "nameKey": "countryCodes.LS",
      "flagIcon": "🇱🇸",
      "phoneCountryCode": "+266"
    },
    {
      "_id": "LR",
      "nameKey": "countryCodes.LR",
      "flagIcon": "🇱🇷",
      "phoneCountryCode": "+231"
    },
    {
      "_id": "LY",
      "nameKey": "countryCodes.LY",
      "flagIcon": "🇱🇾",
      "phoneCountryCode": "+218"
    },
    {
      "_id": "LI",
      "nameKey": "countryCodes.LI",
      "flagIcon": "🇱🇮",
      "phoneCountryCode": "+423"
    },
    {
      "_id": "MG",
      "nameKey": "countryCodes.MG",
      "flagIcon": "🇲🇬",
      "phoneCountryCode": "+261"
    },
    {
      "_id": "MW",
      "nameKey": "countryCodes.MW",
      "flagIcon": "🇲🇼",
      "phoneCountryCode": "+265"
    },
    {
      "_id": "ML",
      "nameKey": "countryCodes.ML",
      "flagIcon": "🇲🇱",
      "phoneCountryCode": "+223"
    },
    {
      "_id": "MH",
      "nameKey": "countryCodes.MH",
      "flagIcon": "🇲🇭",
      "phoneCountryCode": "+692"
    },
    {
      "_id": "MR",
      "nameKey": "countryCodes.MR",
      "flagIcon": "🇲🇷",
      "phoneCountryCode": "+222"
    },
    {
      "_id": "MU",
      "nameKey": "countryCodes.MU",
      "flagIcon": "🇲🇺",
      "phoneCountryCode": "+230"
    },
    {
      "_id": "FM",
      "nameKey": "countryCodes.FM",
      "flagIcon": "🇫🇲",
      "phoneCountryCode": "+691"
    },
    {
      "_id": "MD",
      "nameKey": "countryCodes.MD",
      "flagIcon": "🇲🇩",
      "phoneCountryCode": "+373"
    },
    {
      "_id": "MC",
      "nameKey": "countryCodes.MC",
      "flagIcon": "🇲🇨",
      "phoneCountryCode": "+377"
    },
    {
      "_id": "MN",
      "nameKey": "countryCodes.MN",
      "flagIcon": "🇲🇳",
      "phoneCountryCode": "+976"
    },
    {
      "_id": "ME",
      "nameKey": "countryCodes.ME",
      "flagIcon": "🇲🇪",
      "phoneCountryCode": "+382"
    },
    {
      "_id": "MZ",
      "nameKey": "countryCodes.MZ",
      "flagIcon": "🇲🇿",
      "phoneCountryCode": "+258"
    },
    {
      "_id": "MM",
      "nameKey": "countryCodes.MM",
      "flagIcon": "🇲🇲",
      "phoneCountryCode": "+95"
    },
    {
      "_id": "NA",
      "nameKey": "countryCodes.NA",
      "flagIcon": "🇳🇦",
      "phoneCountryCode": "+264"
    },
    {
      "_id": "NR",
      "nameKey": "countryCodes.NR",
      "flagIcon": "🇳🇷",
      "phoneCountryCode": "+674"
    },
    {
      "_id": "NI",
      "nameKey": "countryCodes.NI",
      "flagIcon": "🇳🇮",
      "phoneCountryCode": "+505"
    },
    {
      "_id": "NE",
      "nameKey": "countryCodes.NE",
      "flagIcon": "🇳🇪",
      "phoneCountryCode": "+227"
    },
    {
      "_id": "NU",
      "nameKey": "countryCodes.NU",
      "flagIcon": "🇳🇺",
      "phoneCountryCode": "+683"
    },
    {
      "_id": "KP",
      "nameKey": "countryCodes.KP",
      "flagIcon": "🇰🇵",
      "phoneCountryCode": "+850"
    },
    {
      "_id": "PW",
      "nameKey": "countryCodes.PW",
      "flagIcon": "🇵🇼",
      "phoneCountryCode": "+680"
    },
    {
      "_id": "PA",
      "nameKey": "countryCodes.PA",
      "flagIcon": "🇵🇦",
      "phoneCountryCode": "+507"
    },
    {
      "_id": "PY",
      "nameKey": "countryCodes.PY",
      "flagIcon": "🇵🇾",
      "phoneCountryCode": "+595"
    },
    {
      "_id": "PR",
      "nameKey": "countryCodes.PR",
      "flagIcon": "🇵🇷",
      "phoneCountryCode": "+1787"
    },
    {
      "_id": "RW",
      "nameKey": "countryCodes.RW",
      "flagIcon": "🇷🇼",
      "phoneCountryCode": "+250"
    },
    {
      "_id": "WS",
      "nameKey": "countryCodes.WS",
      "flagIcon": "🇼🇸",
      "phoneCountryCode": "+685"
    },
    {
      "_id": "SM",
      "nameKey": "countryCodes.SM",
      "flagIcon": "🇸🇲",
      "phoneCountryCode": "+378"
    },
    {
      "_id": "ST",
      "nameKey": "countryCodes.ST",
      "flagIcon": "🇸🇹",
      "phoneCountryCode": "+239"
    },
    {
      "_id": "SN",
      "nameKey": "countryCodes.SN",
      "flagIcon": "🇸🇳",
      "phoneCountryCode": "+221"
    },
    {
      "_id": "RS",
      "nameKey": "countryCodes.RS",
      "flagIcon": "🇷🇸",
      "phoneCountryCode": "+381"
    },
    {
      "_id": "SC",
      "nameKey": "countryCodes.SC",
      "flagIcon": "🇸🇨",
      "phoneCountryCode": "+248"
    },
    {
      "_id": "SL",
      "nameKey": "countryCodes.SL",
      "flagIcon": "🇸🇱",
      "phoneCountryCode": "+232"
    },
    {
      "_id": "SB",
      "nameKey": "countryCodes.SB",
      "flagIcon": "🇸🇧",
      "phoneCountryCode": "+677"
    },
    {
      "_id": "SO",
      "nameKey": "countryCodes.SO",
      "flagIcon": "🇸🇴",
      "phoneCountryCode": "+252"
    },
    {
      "_id": "SS",
      "nameKey": "countryCodes.SS",
      "flagIcon": "🇸🇸",
      "phoneCountryCode": "+211"
    },
    {
      "_id": "SD",
      "nameKey": "countryCodes.SD",
      "flagIcon": "🇸🇩",
      "phoneCountryCode": "+249"
    },
    {
      "_id": "SR",
      "nameKey": "countryCodes.SR",
      "flagIcon": "🇸🇷",
      "phoneCountryCode": "+597"
    },
    {
      "_id": "SZ",
      "nameKey": "countryCodes.SZ",
      "flagIcon": "🇸🇿",
      "phoneCountryCode": "+268"
    },
    {
      "_id": "TJ",
      "nameKey": "countryCodes.TJ",
      "flagIcon": "🇹🇯",
      "phoneCountryCode": "+992"
    },
    {
      "_id": "TZ",
      "nameKey": "countryCodes.TZ",
      "flagIcon": "🇹🇿",
      "phoneCountryCode": "+255"
    },
    {
      "_id": "TL",
      "nameKey": "countryCodes.TL",
      "flagIcon": "🇹🇱",
      "phoneCountryCode": "+670"
    },
    {
      "_id": "TG",
      "nameKey": "countryCodes.TG",
      "flagIcon": "🇹🇬",
      "phoneCountryCode": "+228"
    },
    {
      "_id": "TO",
      "nameKey": "countryCodes.TO",
      "flagIcon": "🇹🇴",
      "phoneCountryCode": "+676"
    },
    {
      "_id": "TT",
      "nameKey": "countryCodes.TT",
      "flagIcon": "🇹🇹",
      "phoneCountryCode": "+1868"
    },
    {
      "_id": "TM",
      "nameKey": "countryCodes.TM",
      "flagIcon": "🇹🇲",
      "phoneCountryCode": "+993"
    },
    {
      "_id": "TV",
      "nameKey": "countryCodes.TV",
      "flagIcon": "🇹🇻",
      "phoneCountryCode": "+688"
    },
    {
      "_id": "UG",
      "nameKey": "countryCodes.UG",
      "flagIcon": "🇺🇬",
      "phoneCountryCode": "+256"
    },
    {
      "_id": "UY",
      "nameKey": "countryCodes.UY",
      "flagIcon": "🇺🇾",
      "phoneCountryCode": "+598"
    },
    {
      "_id": "VU",
      "nameKey": "countryCodes.VU",
      "flagIcon": "🇻🇺",
      "phoneCountryCode": "+678"
    },
    {
      "_id": "VA",
      "nameKey": "countryCodes.VA",
      "flagIcon": "🇻🇦",
      "phoneCountryCode": "+379"
    },
    {
      "_id": "VE",
      "nameKey": "countryCodes.VE",
      "flagIcon": "🇻🇪",
      "phoneCountryCode": "+58"
    },
    {
      "_id": "ZM",
      "nameKey": "countryCodes.ZM",
      "flagIcon": "🇿🇲",
      "phoneCountryCode": "+260"
    },
    {
      "_id": "ZW",
      "nameKey": "countryCodes.ZW",
      "flagIcon": "🇿🇼",
      "phoneCountryCode": "+263"
    }
  ];
}
